//
// Module for edit of flat service table
//
rs.module("system/configuration/flatservicetables/edit",

    [
        "controls/components/event-banner",
        "common/select-helper"
    ],

    function (eventBanner, selectHelper) {

        // Initialize the module
        function initialize(lrsGridApi, jsSelectors, columnIds, ajaxUrls) {

            // ensure errors are not cleared on postback,
            // only execute on selection
            var _executeFlatFrequencyTableDetailsGridSelectionChanged;

            var configurationCard = $.js(jsSelectors.configurationCard);

            var tableKey = configurationCard.js(jsSelectors.tableKey);

            var detailCard = $.js(jsSelectors.detailCard);

            var addDetailButton = detailCard.js(jsSelectors.addDetailButton);

            var detailUpdateToken = detailCard.js(jsSelectors.detailUpdateToken);
            var flatFrequencyTableDetailKey = detailCard.js(jsSelectors.flatFrequencyTableDetailKey);
            var parentFlatFrequencyTableKey = detailCard.js(jsSelectors.parentFlatFrequencyTableKey);
            var frequencySelect = detailCard.js(jsSelectors.frequencySelect);
            var frequencySelectHelper = selectHelper.getHelper(frequencySelect);
            var serviceCredit = detailCard.js(jsSelectors.serviceCredit);

            var cancelDetailButton = detailCard.js(jsSelectors.cancelDetailButton);

                // only call select function of lrsGridApi not on postback
                lrsGridApi.selectionChanged(function (values, rows) {
                    if (_executeFlatFrequencyTableDetailsGridSelectionChanged && values.length > 0) {
                        OnFlatFrequencyTableDetailsGridRowSelect(rows[0]);
                    }

                    _executeFlatFrequencyTableDetailsGridSelectionChanged = true;
                });

                // when add of detail is clicked
                // clear errors and grid selection, default values
                addDetailButton.click(function () {
                    ClearErrorsAndInfoMessagesOfDetailForm();

                    lrsGridApi.selectedValues = null;

                    ClearOrDefaultFieldsOfDetailForm();
                });

                // reset grid selection
                cancelDetailButton.click(function () {
                    ResetFlatFrequencyTableDetailsGridRowSelection();
                });

                // Either select the first row of the grid or manually clear related fields 
                function ResetFlatFrequencyTableDetailsGridRowSelection() {
                    if (lrsGridApi.agGridApi.getDisplayedRowCount() == 0) {
                        // if no rows exist, call for clearing of errors and defaulting of fields that'd normally be called in select event
                        ClearErrorsAndInfoMessagesOfDetailForm();
                        ClearOrDefaultFieldsOfDetailForm();

                    } else if (lrsGridApi.agGridApi.getSelectedNodes().length && lrsGridApi.agGridApi.getSelectedNodes()[0].childIndex == 0) {
                        // if already on first row, selectionChanged won't be fired, so manually call select for row
                        OnFlatFrequencyTableDetailsGridRowSelect(lrsGridApi.selectedRows[0]);

                    } else {
                        lrsGridApi.selectFirstRow();
                    }
                }

                // on selection of a detail grid row,
                // clear errors and messages and set fields for new selection
                function OnFlatFrequencyTableDetailsGridRowSelect(selectedRow) {
                    ClearErrorsAndInfoMessagesOfDetailForm();

                    $.get(
                        ajaxUrls.getDetail,
                        { flatFrequencyTableDetailKey: selectedRow[columnIds.flatFrequencyTableDetailKeyColumnID] },

                        function (data) {
                            detailUpdateToken.val(data.updateToken);
                            flatFrequencyTableDetailKey.val(data.flatFrequencyTableDetailKey);
                            parentFlatFrequencyTableKey.val(data.flatFrequencyTableKey);
                            frequencySelectHelper.setValue(data.frequency.key);
                            serviceCredit.val(data.flatAmount);
                        }
                    );
                }

                // clear messages and client validation of detail fields
                function ClearErrorsAndInfoMessagesOfDetailForm() {
                    eventBanner.removeAllMessages();

                    [
                        detailUpdateToken,
                        flatFrequencyTableDetailKey,
                        parentFlatFrequencyTableKey,
                        frequencySelect,
                        serviceCredit
                    ].forEach((input) => input.clearErrors());
                }

                // set the detail fields for Add
                function ClearOrDefaultFieldsOfDetailForm() {
                    flatFrequencyTableDetailKey.val('-1');
                    parentFlatFrequencyTableKey.val(tableKey.val());

                    frequencySelectHelper.selectIndex(0);

                    [
                        detailUpdateToken,
                        serviceCredit
                    ].forEach((input) => input.val(''));
                }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);